import Handlebars from "utilities/vendor/handlebars/4.7.8/js/handlebars";
import hbs from "utilities/vendor/handlebars/4.7.8/js/handlebars";
import jQuery from "utilities/vendor/jquery/3.7.1/js/jquery";
import $ from "utilities/vendor/jquery/3.7.1/js/jquery";
import spartaStoreUtility from "utilities/global/sparta-store-utility/3.1.2/js/sparta-store-utility";
import spartaEventsUtility from "utilities/global/sparta-events-utility/2.4.2/js/sparta-events-utility";
import spartaTransportUtility from "utilities/global/sparta-transport-utility/4.2.1/js/sparta-transport-utility";
import spartaGlobalFunctions from "utilities/global/sparta-global-functions-utility/2.2.3/js/sparta-global-functions-utility";
import spartaDefensiveCheck from "utilities/global/sparta-defensive-check-utility/1.3.0/js/sparta-defensive-check-utility";
import _ from "utilities/vendor/lodash/4.17.21/js/lodash.custom.min";
import spartaBootstrapUtility from "utilities/global/sparta-bootstrap-utility/4.3.0/js/sparta-bootstrap-utility";
import spartaMessageUtility from "utilities/global/sparta-messaging-utility/2.1.8/js/sparta-messaging-utility";
import spartaRequireUtility from "utilities/global/sparta-require-utility/2.3.5/js/sparta-require-utility";
import spartaExperienceUtility from "utilities/global/sparta-experience-utility/2.4.2/js/sparta-experience-utility";
import moduleContainer from "utilities/helpers/module-container/3.3.5/js/module-container";
import * as jcrUtility from "utilities/global/jcr-utility/1.3.1/js/jcr-utility";
import Communicator from "utilities/global/sparta-module-utility/6.3.1/js/communicator";
import Controller from "utilities/global/sparta-module-utility/6.3.1/js/controller";
import Model from "utilities/global/sparta-module-utility/6.3.1/js/model";
import View from "utilities/global/sparta-module-utility/6.3.1/js/view";

moduleContainer.register(Handlebars);






function loadOnDemandHelpers(helpers) {
    return Promise.all(helpers.map((helper) => spartaRequireUtility.getRequirePromise([helper]))).then((helperExports) => {
        helperExports.forEach((helperExport) => helperExport.register(Handlebars));
    });
}






function getHelpersDependencies(depArray = []) {
    const helpers = depArray.filter(({ id }) => id.match(/utilities\/helpers\/(.+?)\/(\d+\.\d+\.\d+(?:-[a-zA-Z0-9-]+)?)\/js\//));
    return helpers.map(({ id }) => id);
}







const getTemplatesPath = (ref, version) => `modules/${ref}/${version}/js/templates`;







function getCompleteModuleInfo(moduleObj, onDemandModules) {
    let moduleInfo;

    if (moduleObj.mainJs && moduleObj.helpers) {
        moduleInfo = moduleObj;
    }
    else {
        const allModuleVersions = onDemandModules.modules[moduleObj.module];

        if (!allModuleVersions) throw new Error(`Couldn't find the on-demand module ${moduleObj.module}.`);





        moduleInfo = _.cloneDeep(allModuleVersions.find(obj => obj.version === moduleObj.version) || allModuleVersions[0]);
    }


    moduleInfo.context = moduleInfo.context || {};


    moduleObj.context = moduleObj.context || {};


    Object.assign(moduleInfo.context.params, moduleObj.context.params, moduleInfo.context.config);

    return {
        moduleRef: moduleObj.module,
        ...moduleInfo
    };
}




























async function resolveModuleDataSources(customDataSources, defaultDataSources, spaParams) {
    const stringDataSources = _.pickBy(customDataSources, _.isString);
    const contextRootOrSiteName = _.get(spaParams.siteParams, 'contextRoot', spaParams.siteName);
    const jcrManifestDataSources = _.isEmpty(stringDataSources) ? stringDataSources : await jcrUtility.resolveDataSources(contextRootOrSiteName, stringDataSources);
    const resolvedDataSources = {};

    if(!_.isEmpty(jcrManifestDataSources)) {
        await Promise.all(
            _.map(jcrManifestDataSources, (url, key) => new Promise((resolve, reject) => {
                    spartaTransportUtility.subscribe({
                        cache: true,
                        dataType: 'json',
                        success: data => {
                            resolvedDataSources[key] = data;
                            resolve();
                        },
                        error: error => {
                            console.warn(`Unable to load requested datasource:${{ [key]: url }} and will fallback to default datasources`, error);


                            resolve();
                        },
                        url
                    });
                })
            )
        );
    }

        return mapDataSourcesByLanguage({
            ...defaultDataSources,
            ..._.pickBy(customDataSources, _.isObject),
            ...resolvedDataSources,
    });
}

































function mapDataSourcesByLanguage(dataSources) {
    const mappedDataSources = {};

    _.each(dataSources, (dataSource, key) => {
        const source = {};
        source[window.sparta.language] = dataSource;

        mappedDataSources[key] = source;
    });

    return mappedDataSources;
}







function getModuleTemplate(module, version) {
    return spartaRequireUtility.getRequirePromise([getTemplatesPath(module, version)]);
}





function registerModuleTemplates(moduleInit) {
    (moduleInit.default.templates || []).forEach(templateObj => {
        Handlebars.registerPartial(templateObj.name, Handlebars.template(templateObj.precompiled));
    });
}







function getAndRegisterModuleTemplates(moduleRef, version) {
    return getModuleTemplate(moduleRef, version).then(moduleInit => {
        registerModuleTemplates(moduleInit);
    });
}







function getModuleMainJs(mainJs) {
    return spartaRequireUtility.getResourceWithDependencies(mainJs).catch(e => {
        throw new Error(`Error fetching module ${mainJs}: ${e.message}.`)
    });
}






function getMountElement(target) {
    const element = target instanceof HTMLElement
        ? target
        : document.querySelector(target);

    if (!(element instanceof HTMLElement)) {
        throw new Error(`Target ${target} isn't a valid HTML element or query selector string.`);
    }

    return element;
}






function getModuleUniqueId(moduleId) {
    if (!document.getElementById(moduleId)) {
        return moduleId;
    }

    let moduleCount = 0;
    while(document.getElementById(moduleId + (++moduleCount)));

    return moduleId + moduleCount;
}

export default class Module {
    constructor(options) {

        let defaults = {
                'target': null,
                '$target': $(),
                'debug': false,
                'events': {
                    'namespace': 'module'
                }
            },
            required = {};

        this.settings = $.extend(true, {}, defaults, options, required);
        this.settings.target = this.settings.class ? this.settings.class : this.settings.target;
        this.settings.$target = $(this.settings.target);
        this.settings.SPARTA_READY = (this.settings.$target.data('sparta-load') === 'primary') ? 'SPARTA_GLOBAL_READY.spartaBootstrapUtility' : 'SPARTA_SECONDARY_READY.spartaBootstrapUtility';




        for ( data in this.settings.data ) {
            if ( this.settings.$target.data( data ) ) {
                this.settings.data[ data ] = this.settings.$target.data( data );
            }
        }

        this.model = new Model({ settings: this.settings });
        this.view = new View({ model: this.model, settings: this.settings });
        this.controller = new Controller({ model: this.model, settings: this.settings });

        this.Events = spartaEventsUtility;
        this.Store =  spartaStoreUtility;
        this.Transport = spartaTransportUtility;
        this.SpartaFunctions = spartaGlobalFunctions;
        this.Experience = spartaExperienceUtility;
        this.Message = spartaMessageUtility;

        this.applicationContext = spartaStoreUtility.getData('applicationContext');
        this.applicationContainer = spartaStoreUtility.getData('applicationContainer');
        this.spaParams = spartaStoreUtility.getData('spaParams');
        this.eventDelegatorString = (this.applicationContext) ? `[data-version='${this.applicationContext.version}'][data-sparta-container='${this.applicationContext.name}']` : '[data-sparta-container]';
        this.isWidget = !!spartaStoreUtility.getData('isWidget');

        this.params = this.settings.$target.data('module-parameters');

                if (this.isWidget && this.applicationContext.id) {
            this.spaParams = this.spaParams[this.applicationContext.id];
        }        


        this.settings.moduleInfo = {
            name: this.settings.$target.data('module'),
            version: this.settings.$target.data('version')
        }


        this.settings.moduleInfo.options = this.Store.getData('applicationOptions')[this.settings.moduleInfo.name];

        const onDemandModules = this.spaParams.onDemandModules || {};
        this.baseHelpersPromise = onDemandModules && onDemandModules.baseHelpers ?
            loadOnDemandHelpers(onDemandModules.baseHelpers) :
            undefined;


        spartaBootstrapUtility.register(this);
    }
















































    mountAll(modules) {
        if (spartaDefensiveCheck.isObject(modules) || spartaDefensiveCheck.isArray(modules)) {
            if (this.baseHelpersPromise) {
                return this.baseHelpersPromise.then(async () => {
                    const moduleArray = Array.isArray(modules) ? modules : [modules];
                    const modulesMetaData = await this._loadModulesWithMetaData(moduleArray);
                    return Promise.all(modulesMetaData.map(this._mount.bind(this)));
                });
            }
            return Promise.reject(new Error('No on-demand modules found.'));
        } else {
            console.error('sparta-module-utility:mountAll:modules is not an object or array.')
        }
    }














    async _loadModulesWithMetaData(modules) {
        const modulesInfo = _.map(modules, module => ({
            moduleObj: module,
            moduleMetaData: getCompleteModuleInfo(module, this.spaParams.onDemandModules),
        }));
        const uniqueModulesMainJs = _.uniqBy(modulesInfo, 'moduleMetaData.mainJs');
        const modulesLoaded = await Promise.all(_.map(uniqueModulesMainJs, ({ moduleMetaData: { mainJs } }) => getModuleMainJs(mainJs)))

        return _.map(modulesInfo, moduleInfo => {
            return {
                ...moduleInfo,
                loadedModule: _.find(modulesLoaded, { map: { id: moduleInfo.moduleMetaData.mainJs } })
            }
        });
    }















    async _mount(module) {
        const isModuleObj = spartaDefensiveCheck.isObject(module, 'sparta-module-utility:_mount:module is not an Object');
        if (isModuleObj) {
            const {
                moduleMetaData: { moduleRef, helpers, mainJs, version, context },
                loadedModule,
                moduleObj
            } = module;

            const { context: mainModuleContext, map: { id }, depArray } = loadedModule;
            const mainJsInit = mainModuleContext.defined[id];
            const moduleDependencyHelpers = getHelpersDependencies(depArray);
            const allHelpers = [...moduleDependencyHelpers, ...helpers];

            await Promise.all([
                resolveModuleDataSources(moduleObj.context.dataSources, context.dataSources, this.spaParams).then((dataSources) => {
                    context.dataSources = dataSources;
                }),
                loadOnDemandHelpers(allHelpers),
                getAndRegisterModuleTemplates(moduleRef, version),
            ]);

            const element = getMountElement(moduleObj.target);

            context.config.id = getModuleUniqueId(context.config.id);

            element.innerHTML = moduleContainer.helpers.composeModule({
                global: this.spaParams.global,
                params: this.spaParams.siteParams
            }, {
                parameters: this.spaParams.pageParams
            },
                window.sparta.language,
                window.sparta.env,
                undefined,
                context,
            );
            spartaBootstrapUtility.createAndInitModules([mainJsInit]);
            return moduleObj;
        }
    }

    _debug(msg) {
        if ( window.console && this.settings.debug ) {
            console.log( msg );
        }
    };

    static mountAll(moduleObj) {
        const element = moduleObj.target instanceof HTMLElement
            ? moduleObj.target
            : document.querySelector(moduleObj.target);

        const FakeMod = class FakeModule extends Module {
            constructor(options) {
                super(options);
            }

            init(args = {}) {}
        }

        const fakeModuleInstance = new FakeMod({
            target: element
        });


        if (fakeModuleInstance.baseHelpersPromise) {
            return fakeModuleInstance.baseHelpersPromise.then(() => {
                if (Array.isArray(moduleObj)) {
                    return Promise.all(moduleObj.map(fakeModuleInstance.mountAll));
                }

                return fakeModuleInstance.mountAll(moduleObj);
            });
        }

        return Promise.reject(new Error('No on-demand modules found.'));
    }

};
